// extracted by mini-css-extract-plugin
export default {"PostCreate":"qs_a bib_qt bib_a bib_w bib_ea"};